const VIDEO_EXTENSIONS = ['.mp4', '.webm', '.mov', '.m4v'];

/**
 * Whether a media URL points at a clip rather than a still.
 *
 * Videos live in the same `images` table as stills (`is_video = true`), but
 * several read paths don't select that column — notably the
 * `similarity_search_images_v3` RPC behind the public galleries, which returns
 * only `image_url, title, slug, similarity` and does NOT filter clips out. The
 * URL is therefore the only signal those consumers have; every public video
 * row is an `.mp4` (verified across the table), so this holds.
 */
export const isVideoUrl = (url?: string): boolean => {
  if (!url) return false;
  const cleanUrl = url.toLowerCase().split('?')[0].split('#')[0];
  return VIDEO_EXTENSIONS.some((ext) => cleanUrl.endsWith(ext));
};
